import { IQueryBasicData, ID } from '../IQueryData'

export interface IBulkParkingPoolActionError {
  login: string | null
  parkingSubscription: ID | null
  error: string
}

export interface IBulkParkingPoolActionPayload extends IQueryBasicData {
  succeeded: number
  failed: number
  errors: IBulkParkingPoolActionError[]
}

export const BULK_PARKING_POOL_ACTION_FIELDS = `
  status
  code
  error
  message
  succeeded
  failed
  errors {
    login
    parkingSubscription: parking_subscription
    error
  }
`
